<ng-container *ngIf="(breadcrumbs | async) && (breadcrumbs | async).length > 0">
    <!-- <aside id="breadcrumbs">
      <label>
        You are here:
      </label>
      <div>
        <ng-container *ngFor="let breadcrumb of breadcrumbs | async as breadcrumbsArray; let i = index;">
          <a [routerLink]="breadcrumb.routeParams" *ngIf="i != breadcrumbsArray.length - 1">{{breadcrumb.name}}</a>
          <span *ngIf="i == breadcrumbsArray.length - 1" class="current">{{breadcrumb.name}}</span>
        </ng-container>
  
      </div>
    </aside> -->
    <nav class="usa-breadcrumb" aria-label="Breadcrumbs">
        <ol class="usa-breadcrumb__list">
            <ng-container *ngFor="let breadcrumb of breadcrumbs | async as breadcrumbsArray; let i = index;">
                <li class="usa-breadcrumb__list-item" *ngIf="i != breadcrumbsArray.length - 1">
                    <a [routerLink]="breadcrumb.routeParams" class="usa-breadcrumb__link">
                        <span>{{breadcrumb.name}}</span>
                    </a>
                </li>

                <li class="usa-breadcrumb__list-item usa-current" aria-current="page" *ngIf="i == breadcrumbsArray.length - 1">
                    <span>{{breadcrumb.name}}</span>
                </li>
            </ng-container>
        </ol>
    </nav>
  </ng-container>